import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import { Box, xcss } from '@atlaskit/primitives';

const copyableErrorCodeStyles = xcss({
  backgroundColor: 'color.background.neutral',
  font: 'font.code',
  borderRadius: 'border.radius',
  display: 'flex',
  alignItems: 'center',
});

const codeStyles = xcss({
  padding: 'space.100',
});

type CopyableErrorCodeProps = {
  content: string;
};

/**
 * A component that displays a copyable error code.
 *
 * @param {string} content - The error code or ID to display. Will display as code.
 * @returns {JSX.Element} The rendered component.
 */
export function CopyableErrorCode({
  content,
}: CopyableErrorCodeProps): JSX.Element {
  return (
    <Box xcss={copyableErrorCodeStyles} as="div" role="note">
      <Box as="code" xcss={codeStyles}>
        {content}
      </Box>
      {/* TODO: actually make this copy button work */}
      <IconButton icon={CopyIcon} label="copy" />
    </Box>
  );
}
